__turbopack_context__.v({
  "companySelector": "CompanySelector-module__7XdkyG__companySelector",
  "companySelectorActive": "CompanySelector-module__7XdkyG__companySelectorActive",
  "companySelectorInactive": "CompanySelector-module__7XdkyG__companySelectorInactive",
});
